import { render, staticRenderFns } from "./Wbao.vue?vue&type=template&id=6869807f&"
import script from "./Wbao.vue?vue&type=script&lang=js&"
export * from "./Wbao.vue?vue&type=script&lang=js&"
import style0 from "./Wbao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports